import { Component, Input } from '@angular/core';

/**
 * Small info-circle icon with a tooltip. The tooltip content is resolved via
 * the given i18n key so it follows the user's active language.
 *
 * Usage:
 *   <app-help-icon key="admin:dh_profiles:help:landing:card_color"></app-help-icon>
 */
@Component({
  selector: 'app-help-icon',
  template: `
    <i
      class="fa fa-info-circle text-muted ms-1"
      style="cursor: help; font-size: 0.9em;"
      [ngbTooltip]="key | translate"
      container="body"
      triggers="hover focus click"
    ></i>
  `,
})
export class HelpIconComponent {
  @Input() key: string = '';
}
